export class evalueringsstatistikDateRangeRequestModel {
    constructor(startDato: Date, slutDato: Date) {
        this.startDato = startDato.dateToApiPostFormat();
        this.slutDato = slutDato.dateToApiPostFormat();
    }
    startDato: string;
    slutDato: string;
}
